$(document).ready(function () {

	ub.richardson.funcs = {};
	
	ub.richardson.funcs.init = function () {
		ub.branding.useAllColors = true; // Richardson doenst have the concept of limited colors
	};

});